<div style="clear: both; height: 10px; display: block; width: 540px;"></div>
<p class="sectionHeading">
    <span [innerHTML]="text"></span>
</p>
